import React from 'react';
import { Link } from 'react-router-dom';
import './account.css';

const Account = () => {
  const accounts = [
    {
      Account: "Pt. L.R. College of Pharmacy",
      accountNumber: '50200058038632',
      ifscCode: 'HDFC0003592',
      BankName: 'HDFC Bank',
    },
    {
      Account: "Pt. L.R. College of Technology",
      accountNumber: '50200058011706',
      ifscCode: 'HDFC0003592',
      BankName: 'HDFC Bank',
    },
    {
      Account: "Pt. L.R. College of Technology",
      accountNumber: '924010045997853',
      ifscCode: 'UTIB0000792',
      BankName: 'Axis Bank',
    },
    {
      Account: "Pt. L.R. College of Management",
      accountNumber: '924010043254369',
      ifscCode: 'UTIB0000792',
      BankName: 'Axis Bank',
    },
    {
      Account: "Pt. L.R. College of Pharmacy",
      accountNumber: '924010044294076',
      ifscCode: 'UTIB0000792',
      BankName: 'Axis Bank',
    },
  ];

  return (
    <div className="account-container">
      <h1 className="account-title">Payment Account Details</h1>

      {accounts.map((account, index) => (
        <div className="account-card" key={index}>
          <p><strong>Bank Account Name:</strong> {account.Account}</p>
          <p><strong>Bank Name:</strong> {account.BankName}</p>
          <p><strong>Account No:</strong> {account.accountNumber}</p>
          <p><strong>IFSC Code:</strong> {account.ifscCode}</p>
        </div>
      ))}

      <div className="account-buttons">
        <Link to="/AdmissionForm" className="btn">Back to Form</Link>
        <Link to="/Step" className="btn">Show Steps</Link>
      </div>
    </div>
  );
};

export default Account;
